const StudentHistory = ({ studentData }) => {
  console.log(studentData, 'skjdjk');

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString();
  };

  const pauseInfo = studentData;

  if (!pauseInfo) {
    return <div>No pause history data available</div>;
  }

  return (
    <div className="mb-6 rounded-lg border border-dashed border-brand-500 bg-white p-6 shadow-md dark:bg-navy-900">
      <h3 className="mb-4 text-lg font-semibold text-brand-600 dark:text-white">
        Placement Pause History
      </h3>

      <div className="mb-4 rounded-lg border bg-gray-50 p-4 shadow-sm dark:bg-navy-800">
        <p className="font-semibold text-navy-700 dark:text-white">
          Current Status:
        </p>
        <div className="mt-2 grid grid-cols-1 gap-2 text-gray-700 dark:text-gray-300 md:grid-cols-2">
          <div>
            <span className="font-medium">Placement Paused: </span>
            <span
              className={
                pauseInfo.currentStatus.isPlacementPaused
                  ? 'text-red-600'
                  : 'text-green-600'
              }
            >
              {pauseInfo.currentStatus.isPlacementPaused ? 'Yes' : 'No'}
            </span>
          </div>
          <div>
            <span className="font-medium">Paused By Admin: </span>
            <span
              className={
                pauseInfo.currentStatus.isPlacementPausedByAdmin
                  ? 'text-red-600'
                  : 'text-green-600'
              }
            >
              {pauseInfo.currentStatus.isPlacementPausedByAdmin ? 'Yes' : 'No'}
            </span>
          </div>
          <div>
            <span className="font-medium">Permanently Paused: </span>
            <span
              className={
                pauseInfo.currentStatus.isPermanentlyPaused
                  ? 'text-red-600'
                  : 'text-green-600'
              }
            >
              {pauseInfo.currentStatus.isPermanentlyPaused ? 'Yes' : 'No'}
            </span>
          </div>
          <div>
            <span className="font-medium">Has Paused Before: </span>
            <span>{pauseInfo.currentStatus.hasPausedOnce ? 'Yes' : 'No'}</span>
          </div>

          <div>
            <span className="font-medium">Unpause Request: </span>
            <span
              className={
                pauseInfo.currentStatus.currentUnpauseRequestStatus ===
                'pending'
                  ? 'text-yellow-600'
                  : pauseInfo.currentStatus.currentUnpauseRequestStatus ===
                    'approved'
                  ? 'text-green-600'
                  : pauseInfo.currentStatus.currentUnpauseRequestStatus ===
                    'rejected'
                  ? 'text-red-600'
                  : 'text-gray-600'
              }
            >
              {pauseInfo.currentStatus.currentUnpauseRequestStatus === 'none'
                ? 'None'
                : pauseInfo.currentStatus.currentUnpauseRequestStatus
                    .charAt(0)
                    .toUpperCase() +
                  pauseInfo.currentStatus.currentUnpauseRequestStatus.slice(1)}
            </span>
          </div>
        </div>
      </div>

      {/* Pause History Section */}
      <div className="rounded-lg border bg-gray-50 p-4 shadow-sm dark:bg-navy-800">
        <p className="mb-3 font-semibold text-navy-700 dark:text-white">
          Pause History:
        </p>

        {pauseInfo.pauseHistory && pauseInfo.pauseHistory.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="w-full min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              <thead className="bg-gray-100 dark:bg-navy-700">
                <tr>
                  <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-600 dark:text-gray-300">
                    Start Date
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-600 dark:text-gray-300">
                    End Date
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-600 dark:text-gray-300">
                    Duration
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-600 dark:text-gray-300">
                    Reason
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-600 dark:text-gray-300">
                    Unpause Reason
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-600 dark:text-gray-300">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white dark:divide-gray-700 dark:bg-navy-800">
                {pauseInfo.pauseHistory.map((pause, index) => (
                  <tr
                    key={index}
                    className={
                      index % 2 === 0
                        ? 'bg-white dark:bg-navy-800'
                        : 'bg-gray-50 dark:bg-navy-700'
                    }
                  >
                    <td className="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                      {formatDate(pause.startDate)}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                      {formatDate(pause.endDate)}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                      {typeof pause.duration === 'number'
                        ? `${pause.duration} days`
                        : pause.duration}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                      {pause.reason}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                      {pause.unpauseReason || 'N/A'}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      <span
                        className={
                          pause.isPermanent
                            ? 'rounded-full bg-red-100 px-2 py-1 text-xs font-semibold text-red-800 dark:bg-red-900 dark:text-red-200'
                            : pause.endDate
                            ? 'rounded-full bg-green-100 px-2 py-1 text-xs font-semibold text-green-800 dark:bg-green-900 dark:text-green-200'
                            : 'rounded-full bg-yellow-100 px-2 py-1 text-xs font-semibold text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200'
                        }
                      >
                        {pause.isPermanent
                          ? 'Permanent'
                          : pause.endDate
                          ? 'Completed'
                          : 'Ongoing'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-gray-500 dark:text-gray-400">
            No pause history found.
          </p>
        )}
      </div>

      {pauseInfo.currentStatus.unpauseCount > 0 && (
        <div className="mt-4 rounded-lg border border-yellow-200 bg-yellow-50 p-3 dark:border-yellow-800 dark:bg-yellow-900/20">
          <p className="text-sm text-yellow-800 dark:text-yellow-200">
            <span className="font-semibold">Note:</span> Student has used{' '}
            {pauseInfo.currentStatus.unpauseCount} out of 2 allowed unpause
            attempts.
            {pauseInfo.currentStatus.unpauseCount >= 2
              ? ' No more unpause requests can be made.'
              : ` ${2 - pauseInfo.currentStatus.unpauseCount} attempt${
                  2 - pauseInfo.currentStatus.unpauseCount !== 1 ? 's' : ''
                } remaining.`}
          </p>
        </div>
      )}
    </div>
  );
};

export default StudentHistory;
